module.exports = __webpack_public_path__ + "static/img/bg.88d62ed8.png";